// Numbers in Devanagari digits (२ वचन, सेट ७), shared by both courses and the umbrella pages.

/** 12 → "१२". */
export const hiDigits = (value: number | string): string => String(value).replace(/[0-9]/g, d => String.fromCharCode(0x0966 + Number(d)))
